const debug = false
// const debug = "TimeUtils"

export default class TimeUtils {
    roundMinutes(minutes:number, base:number = 1) {
        const numBases = Math.floor(minutes / base);
        const remainder = minutes % base;
        return (numBases + Math.ceil(remainder / base)) * base;
    }

    roundHours(minutes:number) {
        return this.roundMinutes(minutes) / 60;
    }

    static convertToMinutes(timeString:string) {

        if (!timeString) timeString = ""

        // Regular expression to match the time string
        const regex = /(\d+)?(\s*)?(hours|hour|h\.|h)?(\s*)?(\d+)?(\s*)?(minutes|minute|min|m\.|m)?/i

        // Extract the hours and minutes from the time string
        const match         = timeString.match(regex)
        let hours: any      = 0
        let minutes: any    = 0

        if (match) {
            hours   = match[1] ? match[1] : 0
            minutes = match[5] ? match[5] : 0

            // single number entered should be treated as minutes
            if (!minutes && !match[3] /*hours label*/) {
                minutes = hours
                hours   = 0
            }
        }

        // Calculate the total number of minutes
        const totalMinutes = parseInt(hours) * 60 + parseInt(minutes)

        debug && console.log(debug, 'convertToMinutes', timeString, match, totalMinutes)

        return totalMinutes;
    }

    static convertToTimeStringLong(totalMinutes:number) {
        // Calculate the hours and minutes
        const hours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60

        // Construct the time string
        const hoursString   = hours     ? "{0} {1}".f(hours,    hours > 1   ? "hours"   : "hour")   : ''
        const minutesString = minutes   ? "{0} {1}".f(minutes,  minutes > 1 ? "minutes" : "minute") : ''
        const timeString    = '{0}{1}'.f(hoursString ? hoursString + ' ' : '', minutesString ? minutesString : '')

        debug && console.log(debug, 'convertToTimeString', totalMinutes, timeString)

        return timeString
    }

    static convertToTimeString(totalMinutes:number) {
        // Calculate the hours and minutes
        const hours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60

        // Construct the time string
        const hoursString   = hours     ? "{0}{1}".f(hours,    "h") : ''
        const minutesString = minutes   ? "{0}{1}".f(minutes,  "m") : ''
        const timeString    = '{0}{1}'.f(hoursString ? hoursString + ' ' : '', minutesString ? minutesString : '')

        debug && console.log(debug, 'convertToTimeString', totalMinutes, timeString)

        return timeString
    }
}